import { IonButton, IonIcon, IonInput, IonToggle } from '@ionic/react';
import { chevronBackOutline, playOutline } from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';

export const AutomationBuilderHeader: React.FC<{
  name: string;
  savedLabel: string;
  enabled: boolean;
  saving: boolean;
  running: boolean;
  onNameChange: (value: string) => void;
  onEnabledChange: (enabled: boolean) => void;
  onRun: () => void;
  onSave: () => void;
}> = ({
  name,
  savedLabel,
  enabled,
  saving,
  running,
  onNameChange,
  onEnabledChange,
  onRun,
  onSave,
}) => {
  const history = useHistory();
  const metaLabel = savedLabel.startsWith('Saved ')
    ? `Automations · saved ${savedLabel.slice(6).toLowerCase()}`
    : savedLabel === 'Not saved yet'
      ? 'Automations · not saved yet'
      : `Automations · ${savedLabel.toLowerCase()}`;

  return (
    <header className="automation-builder-topbar">
      <button
        type="button"
        className="automation-builder-back"
        aria-label="Back to automations"
        onClick={() => history.push('/automations')}
      >
        <IonIcon icon={chevronBackOutline} />
      </button>
      <div className="automation-builder-title-block">
        <IonInput
          className="automation-builder-title"
          value={name}
          placeholder="Untitled automation"
          onIonInput={(event) => onNameChange(event.detail.value ?? '')}
        />
        <p className="automation-builder-saved">{metaLabel}</p>
      </div>
      <div className="automation-builder-header-actions">
        <label className="automation-builder-enabled">
          <span>Enabled</span>
          <IonToggle
            checked={enabled}
            onIonChange={(event) => onEnabledChange(event.detail.checked)}
          />
        </label>
        <button
          type="button"
          className="automation-builder-run-btn"
          disabled={running || saving}
          onClick={onRun}
        >
          <IonIcon icon={playOutline} aria-hidden />
          {running ? 'Running…' : 'Run now'}
        </button>
        <IonButton
          className="automation-builder-save"
          disabled={saving}
          onClick={onSave}
        >
          Save
        </IonButton>
      </div>
    </header>
  );
};
